var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"url-placement-data"},[_c('ToolNameInputField',{model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"reg extra-details"},[_vm._v("You will be able to run this feature from Slack by using the slash command \"/ply [Feature Name]\"")])])
}]

export { render, staticRenderFns }